var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204,
    height: 204,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M187.639 69.902c5.453-2.043 11.587.712 13.057 6.346a101.996 101.996 0 0 1-4.26 64.298 101.997 101.997 0 0 1-125.454 58.623A101.998 101.998 0 0 1 44.894 17.484a102 102 0 0 1 129.897 13.063c4.078 4.155 3.292 10.833-1.262 14.462-4.554 3.628-11.144 2.818-15.334-1.226a80.914 80.914 0 1 0 22.62 39.905c-1.318-5.672 1.372-11.742 6.824-13.786Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.08 99.16c0 4.644 3.24 8.352 7.956 8.352.612 0 1.044-.072 1.296-.216L69.896 115h7.632l5.544-8.82c1.404-2.268 2.304-4.86 2.304-7.2 0-5.256-4.068-9.18-9.648-9.18-5.472 0-9.648 3.96-9.648 9.36Zm6.336-.252c0-1.836 1.476-3.24 3.348-3.24 1.872 0 3.312 1.44 3.312 3.276 0 1.836-1.44 3.24-3.312 3.24-1.872 0-3.348-1.44-3.348-3.276Zm21.981 6.012c.54-.864 1.584-1.548 2.916-1.548 1.836 0 3.168 1.296 3.168 3.06s-1.332 3.168-3.168 3.168c-1.908 0-2.952-1.26-3.06-2.376h-6.336c.108 5.004 3.78 8.28 9.504 8.28 5.364 0 9.468-3.996 9.468-9.396 0-4.464-3.204-8.172-7.92-8.172-1.548 0-2.916.396-4.104 1.152l.468-3.168h9.828v-5.616H90.365l-1.836 13.392 5.868 1.224Zm26.96-8.892c0-3.42-2.772-6.084-6.336-6.084-3.564 0-6.336 2.664-6.336 6.084 0 3.42 2.772 6.084 6.336 6.084 3.564 0 6.336-2.664 6.336-6.084Zm-4.248 0c0 1.26-.9 2.124-2.088 2.124-1.188 0-2.088-.864-2.088-2.124 0-1.26.9-2.124 2.088-2.124 1.188 0 2.088.864 2.088 2.124Zm17.748-5.76h-5.508L110.989 115h5.508l18.36-24.732Zm-10.368 18.972c0 3.42 2.772 6.084 6.336 6.084 3.564 0 6.336-2.664 6.336-6.084 0-3.42-2.772-6.084-6.336-6.084-3.564 0-6.336 2.664-6.336 6.084Zm4.248 0c0-1.26.9-2.124 2.088-2.124 1.188 0 2.088.864 2.088 2.124 0 1.26-.9 2.124-2.088 2.124-1.188 0-2.088-.864-2.088-2.124Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -12.435,
    x2: 228.124,
    y1: 91.215,
    y2: 92.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter1);
export default __webpack_public_path__ + "static/media/meter1.35edfdfec3d86c0ecc6eef22b531d44d.svg";
export { ForwardRef as ReactComponent };